var React = require('react');

function BulbRed (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 3.125c-2.106 0-3.818 1.682-3.818 3.75a.63.63 0 00.636.625.63.63 0 00.637-.625c0-1.379 1.142-2.5 2.545-2.5a.63.63 0 00.636-.625A.63.63 0 007 3.125zM3.82 17.937c0 .123.038.243.107.345l.975 1.44a.64.64 0 00.53.278h3.136a.639.639 0 00.53-.279l.974-1.439a.62.62 0 00.107-.345l.002-1.687H3.819l.002 1.687zM7 0C2.932 0 0 3.241 0 6.875c0 1.733.654 3.315 1.732 4.523.662.742 1.7 2.297 2.085 3.6V15h1.91v-.004c0-.187-.03-.372-.086-.55a12.253 12.253 0 00-2.473-4.284 4.933 4.933 0 01-1.257-3.287c-.008-2.876 2.373-5 5.089-5 2.807 0 5.09 2.243 5.09 5 0 1.21-.446 2.377-1.258 3.287a12.281 12.281 0 00-2.47 4.276c-.058.18-.088.369-.088.558V15h1.909v-.002c.385-1.303 1.423-2.858 2.085-3.6A6.77 6.77 0 0014 6.875C14 3.078 10.866 0 7 0z","fill":"#E42612","fillRule":"nonzero"}));
}

BulbRed.defaultProps = {"width":"14","height":"20","viewBox":"0 0 14 20"};

module.exports = BulbRed;

BulbRed.default = BulbRed;
